import swal from 'sweetalert'

export default class PaypalHelper {
    static async loadPaypalSdk(currency = `CAD`, debug = false) {
        if (this.paypalSdkLoaded) {
            if (this.currency !== currency) {
                swal({
                    title: `Country changed`,
                    text: `You need to reload the page because the currency changed.`,
                    icon: `info`
                }).then(() => {
                    window.location.reload();
                });
            }

            return new Promise(resolve => {
                resolve();
            });
        }

        if (!window.env.VUE_APP_PAYPAL_CLIENT) {
            throw new Error(`Environment variable VUE_APP_PAYPAL_CLIENT is not defined.`);
        }

        this.paypalSdkLoaded = true;
        this.currency = currency;

        return new Promise(resolve => {
            let script = document.createElement(`script`);
            let src = `https://www.paypal.com/sdk/js?client-id=${window.env.VUE_APP_PAYPAL_CLIENT}&currency=${currency}&vault=true`;
            if (window.env.VUE_APP_ENV !== `live`) {
                src += `&buyer-country=CA`;

                if (debug) {
                    src += `&debug=true`;
                }
            }

            script.setAttribute(`src`, src);

            script.onload = () => {
                resolve();
            };
            document.head.appendChild(script);
        });
    }

    static async addPaypalButtons(elementId, price, onApprove, options) {
        let paypalContainer = document.getElementById(elementId);
        if (!paypalContainer) {
            throw new Error(`${elementId} not found.`);
        }

        let payer;

        if (!options) {
            options = {};
        }

        if (!options.currency) {
            options.currency = `CAD`;
        }

        if (options.first_name || options.email || options.phone) {
            payer = {};
        }

        if (options.first_name) {
            payer.name = {
                given_name: options.first_name,
                surname: options.last_name
            };
        }

        if (options.email) {
            payer.email_address = options.email;
        }

        if (options.phone) {
            payer.phone = {
                phone_type: options.phone_type || `MOBILE`,
                phone_number: {
                    national_number: options.phone.replace(/[+\s-()]/g, ``)
                }
            }
        }

        if (options.address && options.postal_code) {
            payer.address = {
                address_line_1: options.address,
                address_line_2: options.address_complement,
                admin_area_2: options.city,
                admin_area_1: options.state,
                postal_code: options.postal_code,
                country_code: options.country ? options.country.toUpperCase() : `CA`
            }
        }

        // console.log(payer);

        paypalContainer.innerHTML = ``;
        paypal.Buttons({
            enableStandardCardFields: true,
            createOrder(data, actions) {
                return options.createPaypalPayment(payer)
                    .then(resp => {
                        return resp.data.id;
                    });
            },
            onClick: options.onClick,
            onCancel: options.onCancel,
            onApprove(data) {
                onApprove(data.orderID);
            }
        }).render(`#${elementId}`);
    }
}
